import { ApplicationInsights } from "@microsoft/applicationinsights-web";

const start = () => {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: process.env.REACT_APP_CONNECTION_STRING
    }
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView();
};

export default { start };
